import ProductsSearch from './ProductsSearch';

export default ProductsSearch;
